<div class="row">
  <div class="col-6 input-group">
    <select class="custom-select" id="search" [(ngModel)]="sucursal">
      <option disabled value="">Seleccione...</option>
      <option *ngFor="let plant of plants" [value]="plant.id_planta">{{plant.nom_planta}}</option>
    </select>
    <input type="text" id="nombre_fc" class="form-control" [placeholder]="'Ingrese el Nombre'" [(ngModel)]="nombre_fc"
      required>
    <span class="input-group-btn">

      <button class="btn btn-primary rounded-0" (click)="refresh(1,nombre_fc,sucursal)">Buscar</button>
    </span>
  </div>
</div>






<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
  <div class="btn-toolbar mb-2 mb-md-0">
    <!-- *ngIf="canAccess(['edit_users'])"-->
    <!-- <a routerLink="/plants/create" class="btn btn-sm btn-outline-secondary">Agregar</a> -->
    <button (click)="mostrarBootstrapModal(null,'save')"  class="btn btn-sm btn-outline-secondary" >Agregar</button>
  </div>
</div>

<div class="table-responsive">
  <table class="table">
    <thead>
      <tr>
        <th>id</th>
        <th>orde ceco</th>
        <th>tipo dv</th>
        <th>nombre_fc</th>
        <th>base_salario</th>
        <th>v diur</th>
        <th>v noc</th>
        <th>v fes_d</th>
        <th>v fes_n</th>
        <th>v diur ext</th>
        <th>v noc ext</th>
        <th>v fes d_ext</th>
        <th>v fes n_ext</th>
        <th>v f d s c</th>
        <th>v f n s c</th>
        <th>base salario cli</th>
        <th>v diur cli</th>
        <th>v noc_cli</th>
        <th>v fes d cli</th>
        <th>v fes n cli</th>
        <th>v diur ext cli</th>
        <th>v noc ext cli</th>
        <th>v fes d ext cli</th>
        <th>v fes n ext cli</th>
        <th>v f d s c cli</th>
        <th>v f n s c cli</th>
        <th>v_unidad</th>
        <th>jornales</th>
        <th>Action</th>

      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let fc of fuenteContrato">
        <td>{{fc.id_fc}}</td>
        <th>{{fc.orden_ceco}}</th>
        <th>{{fc.tipo_dv}}</th>
        <th>{{fc.nombre_fc}}</th>
        <th>{{fc.base_salario}}</th>
        <th>{{fc.v_diur}}</th>
        <th>{{fc.v_noc}}</th>
        <th>{{fc.v_fes_d}}</th>
        <th>{{fc.v_fes_n}}</th>
        <th>{{fc.v_diur_ext}}</th>
        <th>{{fc.v_noc_ext}}</th>
        <th>{{fc.v_fes_d_ext}}</th>
        <th>{{fc.v_fes_n_ext}}</th>
        <th>{{fc.v_f_d_s_c}}</th>
        <th>{{fc.v_f_n_s_c}}</th>
        <th>{{fc.base_salario_cli}}</th>
        <th>{{fc.v_diur_cli}}</th>
        <th>{{fc.v_noc_cli}}</th>
        <th>{{fc.v_fes_d_cli}}</th>
        <th>{{fc.v_fes_n_cli}}</th>
        <th>{{fc.v_diur_ext_cli}}</th>
        <th>{{fc.v_noc_ext_cli}}</th>
        <th>{{fc.v_fes_d_ext_cli}}</th>
        <th>{{fc.v_fes_n_ext_cli}}</th>
        <th>{{fc.v_f_d_s_c_cli}}</th>
        <th>{{fc.v_f_n_s_c_cli}}</th>
        <th>{{fc.v_unidad}}</th>
        <th>{{fc.id_jornales}}</th>
        <td class="text-nowrap">
   
            <a href="javascript:void(0)" (click)="mostrarBootstrapModal(fc.id_fc,'edit')" class="btn  btn-outline-secondary mr-2"><i class="fa fa-pencil "></i></a>
            <a href="javascript:void(0)" (click)="delete(fc.id_fc)" class="btn  btn-outline-danger"><i class="fa fa-trash-o "></i></a>
          
        </td>
      </tr>
    </tbody>
  </table>
</div>

<app-paginator [lastPage]="lastPage" (pageChanged)="refresh($event)"></app-paginator>
